<script setup lang="ts">
import type { Component } from 'vue'
import AppButton from '../AppButton/AppButton.vue'
import AppTooltip from '../AppTooltip/AppTooltip.vue'

defineOptions({ inheritAttrs: false })

withDefaults(
  defineProps<{
    /** Accessible name, announced to screen readers and used as the tooltip fallback. */
    label: string
    /** Glyph rendered for this action (e.g. a Solar icon). */
    icon: Component
    /** Tooltip text shown on hover and keyboard focus; falls back to `label`. */
    tooltip?: string
    /** Ink: `ghost` (tertiary, default) for actions on content · `ghost-strong` (primary) for a page header's actions. */
    variant?: 'ghost' | 'ghost-strong'
    /** Button size: `sm` (28px) for a standalone icon toolbar or row action · `md` (36px, default) beside other md controls. */
    size?: 'sm' | 'md'
  }>(),
  { tooltip: undefined, variant: 'ghost', size: 'md' },
)
</script>

<template>
  <AppTooltip :content="tooltip ?? label">
    <template #trigger="{ aria }">
      <AppButton
        :size="size"
        :variant="variant"
        icon-only
        :start-icon="icon"
        :aria-label="label"
        v-bind="{ ...aria, ...$attrs }"
      />
    </template>
  </AppTooltip>
</template>
